module.exports = __webpack_public_path__ + "img/map_search_info_icon02.9aa7629f.svg";